import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { BiArrowBack, BiCheck } from "react-icons/bi";
import { MdMoreHoriz } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";

export const PUBLISH_STATES = {
  NOT_READY: "NOT_READY",
  READY: "READY",
  PUBLISHED: "PUBLISHED",
};

const BUTTON = "dynamic-documents-editor__btn";

const PublishButton = ({ state, ready, total, onPublish }) => {
  const { t } = useTranslation(
    NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS_EDITOR,
  );
  if (state === PUBLISH_STATES.NOT_READY)
    return (
      <button
        type="button"
        className={`${BUTTON} ${BUTTON}--primary`}
        disabled
        title={t("HEADER.REMAINING", { count: total - ready })}
      >
        {t("HEADER.PUBLISH_PROGRESS", { ready, total })}
      </button>
    );
  if (state === PUBLISH_STATES.PUBLISHED)
    return (
      <button
        type="button"
        className={`${BUTTON} ${BUTTON}--done`}
        aria-disabled="true"
        title={t("HEADER.NOTHING_TO_PUBLISH")}
      >
        <BiCheck size={18} />
        {t("HEADER.PUBLISHED")}
      </button>
    );
  return (
    <button
      type="button"
      className={`${BUTTON} ${BUTTON}--primary`}
      onClick={onPublish}
    >
      {t("HEADER.PUBLISH")}
    </button>
  );
};

const EditorHeader = ({
  name,
  saving,
  failing,
  onRetry,
  onBack,
  lucie,
  menu,
  publish,
  children,
}) => {
  const { t } = useTranslation(
    NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS_EDITOR,
  );
  const HEADER = t("HEADER", { returnObjects: true });

  return (
    <header className="dynamic-documents-editor__header">
      <div className="dynamic-documents-editor__header-row">
        <div className="dynamic-documents-editor__header-left">
          <button
            type="button"
            className="dynamic-documents-editor__back"
            onClick={onBack}
          >
            <BiArrowBack size={16} />
            {HEADER.BACK}
          </button>
          <span
            className="dynamic-documents-editor__crumb"
            aria-hidden="true"
          />
          <h1 className="dynamic-documents-editor__title">
            {name || HEADER.UNTITLED}
          </h1>
          {saving && (
            <span className="dynamic-documents-editor__saving">
              {HEADER.SAVING}
            </span>
          )}
          {!saving && failing && (
            <span className="dynamic-documents-editor__save-failed">
              {HEADER.SAVE_FAILED}{" "}
              <span className="dynamic-documents-editor__dot" />{" "}
              <button
                type="button"
                className="dynamic-documents-editor__link dynamic-documents-editor__link--danger"
                onClick={onRetry}
              >
                {HEADER.RETRY}
              </button>
            </span>
          )}
        </div>
        <div className="dynamic-documents-editor__header-right">
          <button
            type="button"
            className={`${BUTTON} ${BUTTON}--sm`}
            disabled={lucie.disabled}
            onClick={lucie.onAsk}
          >
            <span
              className="dynamic-documents-editor__avatar"
              aria-hidden="true"
            >
              {t("LUCIE.AVATAR")}
            </span>
            {t(lucie.running ? "LUCIE.RUNNING" : "LUCIE.ASK")}
          </button>
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: menu.items,
              onClick: ({ key }) => menu.onClick(key),
            }}
          >
            <button
              type="button"
              className="dynamic-documents-editor__icon-btn"
              aria-label={HEADER.MORE}
              title={HEADER.MORE}
            >
              <MdMoreHoriz size={20} />
            </button>
          </Dropdown>
          <PublishButton {...publish} />
        </div>
      </div>
      {children}
    </header>
  );
};

export default EditorHeader;
